export default __webpack_public_path__ + "dd173772c58dc21855cb687699cffac4.svg";